import './notification-toast-wrap.styles.scss';

export default angular.module('directives.abNotificationToastWrap', [])
  .directive('abNotificationToastWrap', () => {
    'ngInject';

    return {
      restrict: 'E',
      replace: true,
      templateUrl: require('./notification-toast-wrap.template.html'),
    };
  })
  .name;
